//
//

export default {
  name: 'middlePage',
  async created() {
    const qrcodeId = this.params.qrcodeId
    this.$http.sendRecordNoToken({
      orderNum: qrcodeId,
      bizCode: '',
      appId: '',
      userId: 0,
      eventKey: '802',
      eventValue: '',
      pageId: '1234'
    })
    const { url } = await this.doRequest('wxScan', {
      twoDimensionalId: qrcodeId
    })
    location.href = `${url}&qrcodeId=${qrcodeId}`
  }
}
